import { colors } from '@configs/styles/config'
import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  children?: ReactNode
  color?: string
  width?: string
  height?: string
  rotate?: string
}

const GiftIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height } = props
  return (
    <svg
      width={width ? width : '100%'}
      height={height ? height : '100%'}
      viewBox="0 0 15 15"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <rect id="path-1" x="0" y="0" width="1920" height="380"></rect>
      </defs>
      <g id="УГУ" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="courses" transform="translate(-235.000000, -409.000000)">
          <g id="Group-5" transform="translate(1.000000, 93.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
          </g>
          <rect
            id="Rectangle"
            stroke="#65677C"
            x="208.5"
            y="389.5"
            width="257"
            height="56"
            rx="7"
          ></rect>
          <g
            id="giftbox"
            transform="translate(235.000000, 409.000000)"
            fill={colors.uguBrightPurple}
            fillRule="nonzero"
          >
            <path
              d="M14.0217207,2.98652395 L12.9298576,2.98652395 C13.0738807,2.75248275 13.1689196,2.489773 13.1960191,2.2119318 C13.2825912,1.32398909 12.8271722,0.528008335 12.0518319,0.175111501 C11.3391575,-0.149267203 10.5382704,-0.0166639081 9.96156258,0.520427566 L8.58285433,1.80344265 C8.314349,1.50189651 7.92836342,1.31237728 7.49998535,1.31237728 C7.07084556,1.31237728 6.68424476,1.50249815 6.41568083,1.80497686 L5.03521477,0.520277154 C4.45756942,-0.0168143202 3.65700458,-0.148906214 2.94465245,0.175291995 C2.16951725,0.528218912 1.71401032,1.32447041 1.80084609,2.21238303 C1.82800424,2.49001366 1.92298453,2.75260308 2.06697838,2.98652395 L0.978250042,2.98652395 C0.437958129,2.98652395 0,3.43625609 0,3.99100594 L0,5.49774396 C0,5.77510385 0.218993713,6 0.48913967,6 L14.5108603,6 C14.780977,6 15,5.77513393 15,5.49774396 L15,3.99100594 C15,3.43625609 14.5620126,2.98652395 14.0217207,2.98652395 Z M5.99962307,2.83106694 L5.99962307,3 L3.88496823,3 C3.32625113,3 2.88653604,2.41272615 3.0260807,1.75684696 C3.08754712,1.46800633 3.27245792,1.22178602 3.51161964,1.09714287 C3.84003286,0.925993794 4.2038236,0.980938779 4.47965517,1.26243317 L6,2.81613162 C5.99991923,2.82114042 5.99962307,2.82605814 5.99962307,2.83106694 Z M11.9973833,2.0830859 C11.9638577,2.61022645 11.5414197,3 11.0725741,3 L9.0003773,3 L9.0003773,2.83094928 C9.0003773,2.82496491 9.0000539,2.8190413 9,2.81305694 C9.34474179,2.46079959 10.0926256,1.69674501 10.498247,1.28230494 C10.7287755,1.04678828 11.0513376,0.93685215 11.3495102,1.03709786 C11.7773921,1.18096564 12.028672,1.59112249 11.9973833,2.0830859 Z"
              id="Shape"
            ></path>
            <path
              d="M1.21428571,7 L1.21428571,14.0400092 C1.21428571,14.5702165 1.66574017,15 2.22268197,15 L6.92857143,15 L6.92857143,7 L1.21428571,7 Z"
              id="Path"
            ></path>
            <path
              d="M8.07142857,7 L8.07142857,15 L12.777318,15 C13.3342598,15 13.7857143,14.5702165 13.7857143,14.0400092 L13.7857143,7 L8.07142857,7 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default GiftIcon
